import styled, { css } from 'styled-components';
import { Button } from '@/components/UI/Button/Button';
import { Typography } from '@/components/UI/Typography/Typography.styles';
import { AngleIcon } from '@/components/UI/Icons/Icons';

export const DropdownIcon = styled(AngleIcon).attrs({
  width: 11.25,
  height: 6.75,
})``;

export const SortButton = styled(Button)`
  font-size: 14px;
  padding: 0;
  height: 17px;
  color: ${({ theme }) => theme.palette.primary.labels};
`;

export const DesktopSortContainer = styled.div`
  position: relative;
`;

export const DesktopSortButton = styled(Button).attrs<{
  $isActive: boolean;
}>({
  appearance: 'transparent',
  height: 40,
  borderRadius: 20,
})`
  display: flex;
  gap: 10px;
  padding: 15px 21px;
  background-color: ${({ theme }) => theme.palette.secondary.background};
  user-select: none;

  ${({ $isActive }) =>
    $isActive &&
    css`
      ${DropdownIcon} {
        transform: rotate(180deg);
      }
    `}

  ${({ $isActive }) =>
    !$isActive &&
    css`
      &:hover {
        background-color: ${({ theme }) => theme.palette.tertiary.background};
        color: ${({ theme }) => theme.palette.brand.main};

        & path {
          fill: ${({ theme }) => theme.palette.brand.main};
        }
      }
    `}
`;

export const Menu = styled.div`
  display: flex;
  gap: 2px;
  flex-direction: column;
  width: 240px;
  padding: 10px;
`;

export const MenuItem = styled.div<{ $isActive: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 44px;
  padding: 0 15px;
  cursor: pointer;
  border-radius: 14px;
  transition: all 0.1s linear;

  &:hover {
    background-color: ${({ theme }) => theme.palette.secondary.background};
  }
`;

export const MenuItemText = styled(Typography.Body).attrs(() => ({
  $variant: '1',
}))``;

export const RadioButton = styled.div<{ $isActive: boolean }>`
  position: relative;
  width: 20px;
  height: 20px;
  border: 1px solid
    ${({ theme, $isActive }) =>
      $isActive ? theme.palette.brand.main : theme.palette.secondary.border};
  border-radius: 50%;
  background-color: ${({ theme }) => theme.palette.system.white};

  &::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 11px;
    height: 11px;
    border-radius: 50%;
    opacity: ${({ $isActive }) => ($isActive ? 1 : 0)};
    background-color: ${({ theme }) => theme.palette.brand.main};
    display: ${({ $isActive }) => ($isActive ? 'block' : 'none')};
  }
`;
